module.exports = __webpack_public_path__ + "static/media/Coppa-1998-1.d73b78a7.jpg";